import React from 'react';
import { useParams } from 'react-router-dom';
import RackDeviceForm from './form';

export default function RackDeviceUpdate() {
  const { id } = useParams();
  return <RackDeviceForm id={id} />;
}
